import CssBaseline from "@mui/joy/CssBaseline";
import GlobalStyles from "@mui/joy/GlobalStyles";
import InitColorSchemeScript from "@mui/joy/InitColorSchemeScript";
import { CssVarsProvider } from "@mui/joy/styles/CssVarsProvider";
import {
  ThemeProvider as MuiThemeProvider,
  THEME_ID,
} from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";

import { PropsWithChildren } from "react";
import { joyTheme, materialTheme } from "./themes";

export const StyleProvider = ({ children }: PropsWithChildren) => {
  return (
    <MuiThemeProvider theme={{ [THEME_ID]: materialTheme }}>
      <InitColorSchemeScript />
      <CssVarsProvider theme={joyTheme} disableTransitionOnChange>
        <CssBaseline />

        <GlobalStyles
          styles={{
            ":root": {
              "--Form-maxWidth": "800px",
              "--Transition-duration": "0.4s", // set to `none` to disable transition
            },
          }}
        />
        {children}
      </CssVarsProvider>
    </MuiThemeProvider>
  );
};
